import { mainDashboardRoutes } from './main';

export const dashboardRoutes = mainDashboardRoutes;
